import styled from 'styled-components';
import {Input,InputWrapper} from 'styles/ui';

export const TextAreaWrapper:any=styled(InputWrapper)`
  width: 100%;
  height: 180px;
  display: flex;
  flex-direction: column;
  >div:first-child{
	width: 100%;
	flex-grow: 0;
    flex-direction: row;
	justify-content: space-between;
	font-size: 10px;
  }
  >div p{
    color:"#7777"
  }
`;

export const TextBoxStyle:any=styled(Input)`
  resize: none;
  flex-grow: 1;
  margin-top: 1rem;
`;